import { Suspense, lazy } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminCouponsPage = lazy(() =>
  import('../../pages/admin/AdminCouponsPage').then(m => ({
    default: m.AdminCouponsPage,
  }))
);

const ProtectedAdminCouponsPage = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminCouponsPage />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/coupons')({
  component: ProtectedAdminCouponsPage,
});
